<i18n>
{
    "en": {
        "Everyday": "Everyday",
        "Sunday": "Sunday",
        "Monday": "Monday",
        "Friday": "Friday",
        "Tuesday": "Tuesday",
        "Weekday": "Weekday",
        "Thursday": "Thursday",
        "Saturday": "Saturday",
        "Wednesday": "Wednesday",
        "WeekendDay": "Weekend day"
    },
    "vi": {
        "Everyday": "Mỗi ngày",
        "Monday": "Thứ hai",
        "Friday": "Thứ sáu",
        "Tuesday": "Thứ ba",
        "Sunday": "Chủ nhật",
        "Wednesday": "Thứ tư",
        "Saturday": "Thứ bảy",
        "Thursday": "Thứ năm",
        "WeekendDay": "Ngày cuối tuần",
        "Weekday": "Các ngày trong tuần"
    }
}
</i18n>

<template>
    <el-select v-bind="$attrs" v-on="$listeners" class="select-day-option">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
</template>

<script>
export default {
    inheritAttrs: false,
    name: "SelectDayOption",
    data() {
        return {
            options: [
				{ label: this.$t("Everyday"), value: "MO,TU,WE,TH,FR,SA,SU" },
				{ label: this.$t("Monday"), value: "MO" },
				{ label: this.$t("Tuesday"), value: "TU" },
				{ label: this.$t("Wednesday"), value: "WE" },
				{ label: this.$t("Thursday"), value: "TH" },
				{ label: this.$t("Friday"), value: "FR" },
				{ label: this.$t("Saturday"), value: "SA" },
				{ label: this.$t("Sunday"), value: "SU" },
				{ label: this.$t("Weekday"), value: "MO,TU,WE,TH,FR" },
				{ label: this.$t("WeekendDay"), value: "SU,SA" }
			]
        }
    }
}
</script>